/* eslint-disable jsx-a11y/anchor-is-valid */
import checkerboard from '@components/checkerboard';
import { Logo } from '@descope/page-editor-components';
import { Box } from '@mui/material';
import React from 'react';

export default () => (
	<Box
		data-testid="logo-box"
		position="relative"
		height="100%"
		display="flex"
		justifyContent="center"
		sx={{
			background: checkerboard,
			'& > *': { flexShrink: 1 }
		}}
	>
		<Logo style={{ maxHeight: '100%' }} />
	</Box>
);
